import {
  selectCameraStreamByPeerID,
  useHMSActions,
  useHMSStore,
} from "@100mslive/react-sdk";

import React from "react";

const VideoTile = ({ peer, isLocal, mirrorVideo }) => {
  const hmsActions = useHMSActions();
  const videoRef = React.useRef(null);
  const videoTrack = useHMSStore(selectCameraStreamByPeerID(peer.id));

  React.useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement || !videoTrack) return;

    (async () => {
      if (videoTrack.enabled) {
        await hmsActions.attachVideo(videoTrack.id, videoElement);
      } else {
        await hmsActions.detachVideo(videoTrack.id, videoElement);
      }
    })();

    return () => {
      if (videoTrack?.id) {
        hmsActions.detachVideo(videoTrack.id, videoElement);
      }
    };
  }, [videoTrack?.id, videoTrack?.enabled, hmsActions]);

  return (
    <div className="host-video-container-single">
      <video
        ref={videoRef}
        autoPlay={true}
        playsInline
        muted={true}
        className={
          peer?.isLocal && !mirrorVideo
            ? "peer-host-video"
            : "peer-video-host-full"
        }
      ></video>
      <div className="peer-name-host">
        {peer?.isLocal ? `${peer?.name} (You)` : `${peer?.name} (Host)`}
      </div>
      <div className="peer-name-host-multiple-peer">
        {peer?.isLocal ? `${peer?.name} (You)` : `${peer?.name} (Host)`}
      </div>
    </div>
  );
};

export default VideoTile;
